import React from "react";
import "./home.scss";
import Header from "../../section/header/header.jsx";
import Bannercarousel from "../../section/banner-carousel/banner.jsx";
import About from "../../section/about-us/about.jsx";
import Carousellogo from "../../section/carousellogo/carousellogo.jsx";
import Promo from "../../section/promo/promo.jsx";
import Residential from "../../section/residential/residential.jsx";
import Apartment from "../../section/apartment/apartment.jsx";
import Ruko from "../../section/ruko/ruko.jsx";
import Suroundingarea from "../../section/suroundingarea/suroundingarea.jsx";
import Footer from "../../section/footer/footer.jsx";
import ScrollToHashElement from "./ScrollToHashElement.js";
import Bannerhut from "../../section/banner/Bannerbaru.jsx";
import mobileFlyer from "../../section/banner/nw-mobile.png";
import desktopFlyer from "../../section/banner/nw-dekstop.png";
import Rukobaru from "../../section/new-launchingruko/Newlaunchingruko.jsx";
import mobileFlyerR from "../../section/new-launchingruko/flyerruko-mobile.png";
import desktopFlyerR from "../../section/new-launchingruko/flyerruko-desktop.png";
import Sales from "../../section/sales/ConsultationSection.jsx";

const home = () => {
  return (
    <div className="home">
      <ScrollToHashElement />
      <Header />
      <Bannercarousel />
      <Rukobaru mobileFlyerR={mobileFlyerR} desktopFlyerR={desktopFlyerR} />
      {/* <Bannerhut mobileFlyer={mobileFlyer} desktopFlyer={desktopFlyer} /> */}
      <About />
      <Carousellogo />
      {/* <Promo /> */}
      <Residential />
      <Apartment />
      <Ruko />
      <Suroundingarea />
      <Sales />
      <Footer />
    </div>
  );
};

export default home;
